import React from 'react'
import FontAwesome from 'react-fontawesome';
import { useSelector } from 'react-redux'
import { Button, Col, Row } from 'reactstrap';

const FavoriteBoxes = ({ onRecentBox }) => {
  const favoriteBoxes = useSelector(state => state.AppState.favoriteBoxes);
  return (
    favoriteBoxes?.length ? (
      favoriteBoxes?.map(box => {
        return (
          <Row key={box._id}>
            <Col sm="12">
              <Button className="favorite-box" onClick={() => onRecentBox(box)}>
                <p className="display-text">{box.displayName}</p>
                <div className='d-flex align-items-center'>
                  <p className="display-text">{box.serialNumber}</p>
                  <FontAwesome
                    name="star"
                    className="favorite-icon ml-2"
                    style={{ color: '#007bff' }}
                  />
                </div>

              </Button>
            </Col>
          </Row>
        );
      })
    ) : (
      <Row>
        <Col sm="12">
          <p className="display-text">No Starred Box Found!</p>
        </Col>
      </Row>
    )
  )
}

export default FavoriteBoxes
